import { createContext, useContext, type ReactNode } from "react";
import type { PageReviewsContext } from "./reviewTopics";

/**
 * The page's review strip, carried from gatsby-node's onCreatePage
 * (`pageContext.pageReviews`) to wherever the strip renders, through
 * wrapPageElement in gatsby-ssr / gatsby-browser. Pages without a strip get
 * null, so `<PageReviews />` inside shared chrome (FinalCta) is a no-op there.
 */
const ReviewsContext = createContext<PageReviewsContext | null>(null);

export function ReviewsProvider(props: {
  value: PageReviewsContext | null | undefined;
  children: ReactNode;
}) {
  return (
    <ReviewsContext.Provider value={props.value ?? null}>{props.children}</ReviewsContext.Provider>
  );
}

export function usePageReviews(): PageReviewsContext | null {
  return useContext(ReviewsContext);
}

/** wrapPageElement body shared by gatsby-ssr and gatsby-browser. */
export function wrapWithPageReviews(element: ReactNode, pageContext: unknown) {
  const value =
    pageContext && typeof pageContext === "object" && "pageReviews" in pageContext
      ? ((pageContext as { pageReviews?: PageReviewsContext | null }).pageReviews ?? null)
      : null;
  return <ReviewsProvider value={value}>{element}</ReviewsProvider>;
}
